export var EventLevel;
(function (EventLevel) {
    EventLevel[EventLevel["Critical"] = 0] = "Critical";
    EventLevel[EventLevel["Alarm"] = 1] = "Alarm";
    EventLevel[EventLevel["General"] = 2] = "General";
    EventLevel[EventLevel["None"] = 3] = "None";
})(EventLevel || (EventLevel = {}));
